import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Switch,
  TimePicker,
  message,
} from "antd";
import { useEffect, useMemo, useState } from "react";
import moment from "moment";
import dayjs from "dayjs";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { Get, Post } from "../../config/api";
import { ADMIN, BOOKING } from "../../config/constants/api";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import { TiArrowSortedDown } from "react-icons/ti";
import { useNavigate } from "react-router-dom";

const BookChauuffeur = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [chauffeurs, setChauffeurs] = useState([null]);
  const onFinishFailed = (errorInfo) => {};
  const [form] = Form.useForm();
  const token = useSelector((state) => state.user.userToken);
  const [isDropOffVisible, setIsDropOffVisible] = useState(false);
  const onChange = (checked) => {
    setIsDropOffVisible(!checked);
  };
  const [passengerCapacityOptions, setPassengerCapacityOptions] = useState([4]);

  const [pickupLocation, setPickupLocation] = useState({
    address: "",
    coordinates: [0, 0],
    type: "Point",
  });
  const [dropoffLocation, setDropoffLocation] = useState({
    address: "",
    coordinates: [0, 0],
    type: "Point",
  });
  const handlePickupSelect = (newAddress) => {
    setPickupLocation((prevLocation) => ({
      ...prevLocation,
      address: newAddress,
    }));
    form.setFieldsValue({
      pickupLocation: newAddress,
    });

    geocodeByAddress(newAddress)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setPickupLocation((prevLocation) => ({
          ...prevLocation,
          address: newAddress,
          coordinates: [latLng?.lng, latLng?.lat],
        }));
      })
      .catch((error) => console.error("Error", error));
  };
  const handleDestSelect = (newAddress) => {
    setDropoffLocation((prevLocation) => ({
      ...prevLocation,
      address: newAddress,
    }));
    form.setFieldsValue({
      dropoffLocation: newAddress,
    });

    geocodeByAddress(newAddress)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setDropoffLocation((prevLocation) => ({
          ...prevLocation,
          address: newAddress,
          coordinates: [latLng?.lng, latLng?.lat],
        }));
      })
      .catch((error) => console.error("Error", error));
  };
  const handlePickupLocChange = (newAddress) => {
    setPickupLocation((prevLocation) => ({
      ...prevLocation,
      address: newAddress,
    }));
  };
  const handleDestLocChange = (newAddress) => {
    setDropoffLocation((prevLocation) => ({
      ...prevLocation,
      address: newAddress,
    }));
  };

  const handleStartFocus = () => {
    // setStartFocused(true);
  };

  const handleStartBlur = () => {
    // setStartFocused(false);
  };
  const handleDestinationFocus = () => {
    // setDestinationFocused(true);
  };

  const handleDestinationBlur = () => {
    // setDestinationFocused(false);
  };
  const getDurationOptions = () => {
    // If subscription does not exist
    return [
      {
        value: "4",
        label: "4 Hours",
      },
      {
        value: "5",
        label: "5 Hours",
      },
      {
        value: "6",
        label: "6 Hours",
      },
      {
        value: "7",
        label: "7 Hours",
      },
      {
        value: "8",
        label: "8 Hours",
      },
    ];
  };
  const handleVehicleTypeChange = (value) => {
    getChauffeursByService(value);
    if (value === "Black") {
      setPassengerCapacityOptions([4, 5, 6]);
    } else if (value === "Suv") {
      setPassengerCapacityOptions([6, 7]);
    } else {
      setPassengerCapacityOptions([4]);
    }
    form.setFieldsValue({ passengerCapacity: null }); // Reset the field
  };
  const getChauffeursByService = async (serviceType) => {
    Get(ADMIN.getChauffeursByService, token, {
      serviceType: serviceType,
    })
      .then((response) => {
        if (response?.status) {
          console.log(response.data?.docs);
          setChauffeurs(response.data?.docs);
        }
      })
      .catch((err) => {
        console.log("Error fetching chauffeurs ", err);
      });
  };
  useEffect(() => {
    getChauffeursByService("Black");
    // eslint-disable-next-line
  }, []);
  const pickupCoordinates = useMemo(
    () => ({
      lat: pickupLocation.coordinates[1],
      lng: pickupLocation.coordinates[0],
    }),
    [pickupLocation]
  );
  const dropoffCoordinates = useMemo(
    () => ({
      lat: dropoffLocation?.coordinates[1],
      lng: dropoffLocation?.coordinates[0],
    }),
    [dropoffLocation]
  );
  const fetchDirectionsAndDistance = async () => {
    try {
      if (window.google && window.google.maps) {
        const distanceMatrixService =
          new window.google.maps.DistanceMatrixService();

        // Fetch Distance Matrix
        return new Promise((resolve, reject) => {
          distanceMatrixService.getDistanceMatrix(
            {
              origins: [pickupCoordinates],
              destinations: [dropoffCoordinates],
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (response, status) => {
              if (status === window.google.maps.DistanceMatrixStatus.OK) {
                const distanceData = response.rows[0]?.elements[0];
                console.log(distanceData, "distanceData");
                if (
                  distanceData &&
                  distanceData.distance &&
                  distanceData.duration
                ) {
                  // const durationText = distanceData.duration.text;
                  resolve(distanceData); // Return the distanceData
                } else {
                  console.log("Distance data is missing in the response.");
                  message.error("Distance data is missing in the response.");
                  reject("Distance data is missing.");
                }
              } else {
                console.log(`Error fetching distance matrix: ${status}`);
                message.error(
                  `Error fetching distance matrix: ${status}. Please try again.`
                );
                reject(`Error fetching distance matrix: ${status}`);
              }
            }
          );
        });
      } else {
        console.log("Google Maps API is not loaded.");
        message.error("Google Maps API is not loaded. Please try again later.");
        throw new Error("Google Maps API is not loaded.");
      }
    } catch (error) {
      console.log("Error fetching directions or distance matrix:", error);
      message.error("Error fetching data. Please try again.");
      throw error;
    }
  };
  const onFinish = async (values) => {
    const selectedDateTime = moment(
      `${moment(values?.date?.$d).format("YYYY-MM-DD")} ${moment(
        values?.time?.$d
      ).format("HH:mm:ss")}`
    );

    const now = moment();
    const oneHourBuffer = now.clone().startOf("hour"); // Start of the current hour

    if (selectedDateTime.isBefore(oneHourBuffer)) {
      return message.error(
        "You cannot select a past date or time. Please select within the current hour or later."
      );
    }

    let miles = 0;
    if (isDropOffVisible) {
      let distance = await fetchDirectionsAndDistance();
      let distanceInKm = Number(distance.distance.text.split(" ")[0]);
      miles = distanceInKm * 0.621371;
    }
    let data = {
      type: isDropOffVisible ? "PtoP" : "Hourly",
      date: moment(values?.date?.$d).format("YYYY-MM-DD"),
      time: moment(values?.time?.$d).format("YYYY-MM-DD HH:mm"),
      pickupLocation: pickupLocation,
      dropoffLocation: isDropOffVisible ? dropoffLocation : null,
      duration: values?.duration || 0,
      customerName: `${values?.firstName} ${values?.lastName}`,
      email: values?.email,
      phone: "1" + values?.phoneNumber,
      firstName: values?.firstName,
      lastName: values?.lastName,
      chauffeur: values?.selectedChauffeur,
      serviceType: values?.serviceType,
      passengerCapacity: values?.passengerCapacity,
      initialMileage: miles,
    };
    setLoading(true);
    Post(BOOKING.bookChauffeur, data, token)
      .then((response) => {
        if (response?.status) {
          form.resetFields();
          swal(
            "Success",
            "Booking is Pending. Kindly Make Payment to confirm booking",
            "success"
          );
          setLoading(false);
          navigate("/payment", {
            state: {
              type: "Booking",
              total: response?.data?.initialCharges,
              bookingId: response?.data?._id,
              booking: response?.data,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        let message = err?.response?.data?.message || err?.message;
        if (message) {
          swal("Error", message, "error");
        }
      });
  };
  return (
    <Row
      style={{
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Col xs={23} md={23} lg={20}>
        <div
          className="auth-box"
          style={{
            minHeight: "auto",
            height: "auto",
            backgroundColor: "#fff",
            margin: "50px 0",
            padding: "40px",
          }}
        >
          <div className="flex flex-col items-baseline mb-8">
            <h4 className="text-black font-goldman font-bold text-[18px] pb-2">
              {isDropOffVisible ? "Book by Distance" : "Book by Hours"}
            </h4>
            <Switch onChange={onChange} defaultChecked disabled={true} />
          </div>

          <div className="blur-bg-inner-card-form">
            <Form
              className="row g-3"
              name="basic"
              layout="vertical"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              form={form}
            >
              <Row
                style={{ width: "100%", justifyContent: "center" }}
                gutter={[16, 16]}
                className="row-res-margin-0"
              >
                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: "Enter First Name",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter First Name"
                      className="web-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    label="Last Name"
                    name="lastName"
                    rules={[
                      {
                        required: true,
                        message: "Enter Last Name",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter Last Name"
                      className="web-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} md={12} xs={24}>
                  <Form.Item
                    label="Email Address"
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message: "Please enter a valid email address!",
                      },
                      {
                        required: true,
                        message: "Please enter your email address!",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="James.Anderson@gmail.com"
                      className="web-input"
                    />
                  </Form.Item>
                </Col>
                <Col md={12} sm={24} xs={24}>
                  <p
                    className="font-euclid text-sm text-[#34324B] font-bold mb-0"
                    style={{ paddingBottom: "11px" }}
                  >
                    *Phone Number
                  </p>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Input.Group
                      compact
                      style={{ maxWidth: "50px", marginBottom: "auto" }}
                    >
                      <Input
                        value="+1"
                        disabled
                        className="text-sm font-euclid bg-gray-200 web-input"
                        style={{ width: "50px", padding: "15px" }}
                      />
                    </Input.Group>
                    <Form.Item
                      style={{ width: "100%" }}
                      name="phoneNumber"
                      rules={[
                        {
                          required: true,
                          message:
                            "Please enter your phone number (must be 10 digits long excluding +1)!",
                        },
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.reject(
                                "Please enter your phone number!"
                              );
                            }
                            if (!/^\d{10}$/.test(value)) {
                              return Promise.reject(
                                "Phone number must be exactly 10 digits (excluding +1)!"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        size="large"
                        placeholder="Enter Phone Number"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs w-full web-input"
                        style={{
                          MozAppearance: "textfield",
                          width: "100%",
                        }}
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Pick Up Date"
                    name="date"
                    className="flex-1 min-w-[180px] mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please input date!",
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={(current) => {
                        let customDate = moment().format("YYYY-MM-DD");
                        return (
                          current && current < moment(customDate, "YYYY-MM-DD")
                        );
                      }}
                      className="web-input w-full"
                      format="MM/DD/YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Pick Up time"
                    name="time"
                    className="flex-1 min-w-[180px] mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please input time!",
                      },
                    ]}
                  >
                    <TimePicker
                      key={form.getFieldValue("date")}
                      defaultOpenValue={dayjs("00:00", "HH:mm")}
                      format="h:mm A"
                      className="web-input w-full"
                    />
                  </Form.Item>
                </Col>

                {/* for pick up location */}
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Pick Up Location"
                    name="pickupLocation"
                    className="flex-1 min-w-[180px] mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please input location!",
                      },
                    ]}
                  >
                    <PlacesAutocomplete
                      value={pickupLocation?.address}
                      onChange={handlePickupLocChange}
                      onSelect={handlePickupSelect}
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                      }) => {
                        return (
                          <div className="location-drop">
                            <input
                              {...getInputProps({
                                className: "web-input",
                                placeholder: "Search Pickup Location",
                                onFocus: handleStartFocus,
                                onBlur: handleStartBlur,
                              })}
                              style={{ width: "100%" }}
                            />
                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map((suggestion) => {
                                const className = suggestion.active
                                  ? "suggestion-item--active googleSuggestion"
                                  : "suggestion-item googleSuggestion";
                                const style = suggestion.active
                                  ? {
                                      backgroundColor: "#fafafa",
                                      cursor: "pointer",
                                      padding: "5px 10px",
                                    }
                                  : {
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                      padding: "5px 10px",
                                    };
                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                  >
                                    <span>{suggestion.description}</span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      }}
                    </PlacesAutocomplete>
                  </Form.Item>
                </Col>

                {/* for drop off location */}
                <Col md={12} sm={24} xs={24}>
                  {isDropOffVisible && (
                    <Form.Item
                      label="Drop Off Location"
                      name="dropoffLocation"
                      className="flex-1 min-w-[180px] mb-0"
                      rules={[
                        {
                          required: true,
                          message: "Please input your drop location!",
                        },
                      ]}
                    >
                      <PlacesAutocomplete
                        value={dropoffLocation?.address}
                        onChange={handleDestLocChange}
                        onSelect={handleDestSelect}
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => {
                          return (
                            <div className="location-drop">
                              <input
                                {...getInputProps({
                                  placeholder: "Search Dropoff Location",
                                  className: "web-input",
                                  onFocus: handleDestinationFocus,
                                  onBlur: handleDestinationBlur,
                                })}
                                style={{ width: "100%" }}
                              />
                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map((suggestion) => {
                                  const className = suggestion.active
                                    ? "suggestion-item--active googleSuggestion"
                                    : "suggestion-item googleSuggestion";
                                  const style = suggestion.active
                                    ? {
                                        backgroundColor: "#fafafa",
                                        cursor: "pointer",
                                        padding: "5px 10px",
                                      }
                                    : {
                                        backgroundColor: "#ffffff",
                                        cursor: "pointer",
                                        padding: "5px 10px",
                                      };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <span>{suggestion.description}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        }}
                      </PlacesAutocomplete>
                    </Form.Item>
                  )}
                </Col>
                <Col md={12} sm={24} xs={24}>
                  {!isDropOffVisible && (
                    <Form.Item
                      label="Duration"
                      name="duration"
                      className="flex-1 min-w-[180px] mb-0"
                    >
                      <Select
                        placeholder="Select"
                        className="h-12 text-sm font-euclid w-full bg-gray-100 max-sm:text-xs"
                        options={getDurationOptions()}
                      />
                    </Form.Item>
                  )}
                </Col>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Service Type"
                    name="serviceType"
                    className="flex-1 min-w-[180px] mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please input service type!",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      className="h-12 text-sm font-euclid w-full bg-gray-100 max-sm:text-xs"
                      onChange={handleVehicleTypeChange}
                    >
                      <Select.Option value="Black">Black Luxury</Select.Option>
                      <Select.Option value="Ultra">Ultra Luxury</Select.Option>
                      <Select.Option value="Ultra Beyond">
                        Ultra Beyond Luxury
                      </Select.Option>
                      <Select.Option value="Suv">SUV Luxury</Select.Option>
                      <Select.Option value="Sprinter">Sprinter</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Passenger Capacity"
                    name="passengerCapacity"
                    className="flex-1 min-w-[180px] mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please select Passenger Capacity!",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      className="h-12 text-sm font-euclid w-full bg-gray-100 max-sm:text-xs"
                    >
                      {passengerCapacityOptions.map((option) => (
                        <Select.Option key={option} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item
                    name="selectedChauffeur"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] mb-0">
                        Select Chauffeur to Assign
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input Chauffeur!",
                      },
                    ]}
                  >
                    <Select
                      defaultValue="Select"
                      className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs w-fit mr-2"
                      suffixIcon={<TiArrowSortedDown />}
                      options={chauffeurs.map((item) => ({
                        label: (
                          <span className="font-euclid text-sm text-black">
                            {item?.chauffeur?.firstName}{" "}
                            {item?.chauffeur?.lastName}
                          </span>
                        ),
                        value: item?.chauffeur?._id,
                      }))}
                    />
                  </Form.Item>
                </Col>

                <div className="" style={{ textAlign: "center" }}>
                  <Button
                    type=""
                    htmlType="submit"
                    className="uppercase bg-button hover:bg-white hover:border-customGold hover:border-2 font-euclid font-bold text-white px-14 h-[50px] hover:text-customGold text-center text-sm new-hover"
                    disabled={loading}
                    // onClick={() => navigate("/dashboard")}
                  >
                    {!loading ? "Book Chauffeur" : "...loading"}
                  </Button>
                </div>
              </Row>
            </Form>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default BookChauuffeur;
